import { useState as n, useEffect as r } from "react";

var t = function t(r) {
  var t = n(!!r),
      e = t[1];
  return [t[0], function () {
    return e(function (n) {
      return !n;
    });
  }];
},
    e = function e(n, r) {
  return n[r];
},
    i = function i(r) {
  var t = n(r),
      i = t[1];
  return [t[0], function (n) {
    var r = n.target,
        t = r.name,
        o = r.value,
        u = r.checked,
        a = "checkbox" === r.type;
    i(function (n) {
      var r = JSON.parse(JSON.stringify(n)),
          i = t.split("."),
          c = i.slice(0, -1),
          f = i.slice(-1)[0];
      return c.reduce(e, r)[f] = a ? u : o, r;
    });
  }];
},
    o = function o(n) {
  throw new Error(n);
},
    u = function u(n, r) {
  return n.findIndex(function (n) {
    return n.id === r;
  });
},
    a = function a(t) {
  var e = t.initialStep;
  void 0 === e && (e = 0);
  var i = t.autoAdvanceDuration;
  void 0 === i && (i = 0);
  var a = t.steps;
  "production" !== process.env.NODE_ENV && (Array.isArray(a) || Number.isInteger(a) || o("useStep: You must specify either an array or an integer for `steps`"));
  var c = "number" == typeof a ? new Array(a).fill({}) : a,
      f = "number" == typeof e ? e : u(c, e);
  "production" !== process.env.NODE_ENV && "string" == typeof e && -1 === f && o('useStep: id of "' + e + '" specified in initialStep not found in steps');
  var s = n(f),
      v = s[0],
      d = s[1],
      p = n(!1),
      l = p[0],
      g = p[1],
      y = c[v],
      m = y.autoAdvanceDuration;
  void 0 === m && (m = i);

  var N = function N(n) {
    void 0 === n && (n = 1), d((v + c.length + n) % c.length);
  };

  return r(function () {
    var n = !l && m ? setTimeout(N, m) : null;
    return function () {
      return clearTimeout(n);
    };
  }, [v, l]), {
    autoAdvanceDuration: m,
    isPaused: l,
    index: v,
    step: y,
    navigation: {
      next: function next() {
        return N(1);
      },
      previous: function previous() {
        return N(-1);
      },
      go: function go(n) {
        if ("number" == typeof n) "production" !== process.env.NODE_ENV && (n < 0 || n > c.length) && o("useStep: Index out of range in go(" + n + ")"), d(n);else {
          var r = u(c, n);
          "production" !== process.env.NODE_ENV && -1 === r && o('useStep: go("' + n + '") not found in steps'), d(r);
        }
      },
      play: function play() {
        return g(!1);
      },
      pause: function pause() {
        return g(!0);
      }
    }
  };
},
    c = function c(n, r) {
  void 0 === n && (n = 0), void 0 === r && (r = [5e3, 4e3, 1e3]);
  var t = r.map(function (n) {
    return {
      autoAdvanceDuration: n
    };
  });
  return a({
    initialStep: n,
    steps: t
  }).index;
};

export { t as useNot, i as useForm, c as useTrafficLight, a as useStep };